import { tokens } from "../../theme";
import * as React from "react";
import * as CONSTANT from "../../constants/Constant";

import DownloadDropdownButton from "../../components/DownloadDropdownButton";
import { saveAs } from "file-saver";

import {
  Box,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import SectionHeader from "../../components/SectionHeader";
import Grid from "@mui/material/Unstable_Grid2"; // Grid version 2
import { DataGrid } from "@mui/x-data-grid";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import {
  getFromLocalStorage,
  saveToLocalStorageJsonObject,
  getFromLocalStorageJsonObject,
} from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAtom } from "jotai";
import {
  isAuthPageAtom,
  showErrorAlertDialog,
} from "../../config/AppConfig";
import {
  ALERT,
  ERROR_WHILE_FETCHING_DATA,
  NO_INTERNET_CONNECTION_FOUND,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
  DOWNLOADING_REPORT,
  LOADING_PLEASE_WAIT,
} from "../../constants/Strings";
import { initializeEncryption } from "../../services/AesGcmEncryption";
import DebugLog from "../../utils/DebugLog";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_ROLE,
  USER_NAME,
  SELECTED_TRANSACTION_TYPE,
  } from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import {
  downloadPayoutsReports,
  getExclusionTotalHeaderSummaryForTransactionType,
  getExclusionTransactionTypeRequest,
} from "../../services/ApiService";
import HighlightsPrimary from "../../components/HighlightsPrimary";
import HighlightsSecondary from "../../components/HighlightsSecondary";


import NoDataFound from "../../components/NoDataFound";
import { exclusionTransactionTypeColumnHeader } from "../../components/ColumnHeader";
import { formatPrice } from "../../utils/PriceFormatter";

import { getButtonVisibilityData } from "../../utils/GetButtonVisibilityAsPerLoginResponse";

const RemovedExclusionTransactionTypeScreen = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNetworkConnectionAvailable = UseOnlineStatus();

  const navigate = useNavigate();
  const location = useLocation();
  let selectedPayoutCycle = location.state;

  const [, setAuthStatus] = useAtom(isAuthPageAtom);
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");

  const [transactionTypeName, setTransactionTypeName] = useState("");
  const [payoutDealerHeaderSummary, setPayoutDealerHeaderSummary] = useState(null); // Sample Data == {"dealerTotal":579.5,"dealerPrepaidAmount":0,"dealerPostpaidAmount":579.5,"masterDealerTotal":0,"masterDealerPrepaidAmount":0,"masterDealerPostpaidAmount":0}}
  const [transactionType, setTransactionType] = useState([]);

  const [gridHeight, setGridHeight] = useState(108); // Default height
  const [rowsPerPage, setRowsPerPage] = useState(0); // Used to set the height of the grid

  // pagination
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });
  const [pageSize, setPageSize] = useState(15);
  const [totalNoOfRows, setTotalNoOfRows] = useState(0);
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);

  const [selectedRows, setSelectedRows] = React.useState([]);
  const [userRole, setUserRole] = useState([]);
  // State to store the extracted IDs
  
  // button visibility
  const [downloadButtonVisible, setDownloadButton] = useState(false);


  useEffect(() => {
   DebugLog("dataProps >>>>"+JSON.stringify(selectedPayoutCycle))

    getUserRole();
    updateButtonVisibility();
    checkPageNavTransactionDetails();

    setTransactionTypeName(selectedPayoutCycle?.data.clientName);

      fetchData(
        selectedPayoutCycle?.data.yesId,
        selectedPayoutCycle?.data.billingAccountNo
      );
  }, []);

  useEffect(() => {

    getDataGridHeight();

    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate, rowsPerPage]);

  async function fetchData(yesId, billingAccountNo) {
    try {
   

      getTotalHeaderSummary(billingAccountNo);
      //getDealerHeaderSummary(billingAccountNo);
      getExclusionTransactionType(yesId, billingAccountNo);
    } catch (error) {
      handleError(error);
    }
  }


  function getUserRole() {
    setUserRole(getFromLocalStorage(USER_ROLE));
  }
  // increase - decrease list layout height on available list itmes count
  function getDataGridHeight() {
    // Calculate the total height required for the grid
    const headerHeight = 60; // Height of header row
    const rowHeight = 60; // Height of each data row
    let rowCount = 0;
    if (rowsPerPage <= pageSize) {
      rowCount = rowsPerPage; // Total number of data rows
    } else {
      rowCount = pageSize; // Total number of data rows
    }

    const totalHeight = headerHeight + rowCount * rowHeight;

    // Set the grid height
    setGridHeight(totalHeight);
  }

  function checkPageNavTransactionDetails() {
    // If selectedPayoutCycle is not in the location state (e.g., after a page refresh),
    // try to retrieve it from localStorage
    if (!selectedPayoutCycle) {
      const storedData = getFromLocalStorageJsonObject(
        SELECTED_TRANSACTION_TYPE,
        JSON.stringify(selectedPayoutCycle)
      );
      selectedPayoutCycle = storedData ? JSON.parse(storedData) : null;
    } else {
      // If payoutRowSelected is in the location state, store it in localStorage
      saveToLocalStorageJsonObject(
        SELECTED_TRANSACTION_TYPE,
        JSON.stringify(selectedPayoutCycle)
      );
    }
  }

  const updateButtonVisibility  = () => {
    const actionButtonList = getButtonVisibilityData("Exclusions")
    if(actionButtonList){
     
      actionButtonList.forEach((items, index) => {
        if (items.buttonName === "DOWNLOAD") {
          setDownloadButton(true);
        }
      });
    }
  }


  /********  Pagination Methods ***********/
  const handlePageJump = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationModel({ pageSize: pageSize, page: newPage });
    checkPageNavTransactionDetails();

    getExclusionTransactionType(
      selectedPayoutCycle?.batchNo,
      selectedPayoutCycle?.commissionType,
      newPage,
      paginationModel.pageSize
    );
  };

  const handlePageChange = (newPage) => {
    setPaginationModel({ pageSize: pageSize, page: newPage });
    checkPageNavTransactionDetails();

    getExclusionTransactionType(
      selectedPayoutCycle?.batchNo,
      selectedPayoutCycle?.commissionType,
      newPage,
      paginationModel.pageSize
    );
  };

  const handlePageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSize(newPageSize);
    setPaginationModel({ pageSize: newPageSize, page: 0 });
    checkPageNavTransactionDetails();

    // call api with new page size and start from page 0.
    getExclusionTransactionType(
      selectedPayoutCycle?.batchNo,
      selectedPayoutCycle?.commissionType,
      0,
      newPageSize
    );
  };

  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
  };

  const resetSelection = () => {
    setSelectedRows([]);
  };

  /****** API Calls ******/
  async function getTotalHeaderSummary(billingAccountNo) {
    try {
      if (!isNetworkConnectionAvailable) {
        throw new Error(NO_INTERNET_CONNECTION_FOUND);
      }
      setProgressbarText(LOADING_PLEASE_WAIT);
      setLoading(true); // Hide the progress dialog

      const contentData = {
        billingAccountNo: billingAccountNo,
      };

      const encryptedContentData = await initializeEncryption(
        contentData,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.PAYOUT_TOTAL_HEADER_SUMMARY
      );

      const transactionTypeRequestData = {
        requestId: generateRequestId(),
        loginId: getFromLocalStorage(LOGIN_ID),
        sessionId: getFromLocalStorage(SESSION_ID),
        loginUserName: getFromLocalStorage(USER_NAME),
        contentData: encryptedContentData,
      };

      getExclusionTotalHeaderSummaryForTransactionType(transactionTypeRequestData)
        .then((response) => {
          try{
            
            setPayoutDealerHeaderSummary(response.data.result);
  
          }catch (e) {
          DebugLog(e.toString())
          }
        
          setLoading(false);
        })
        .catch((error) => {
          handleError(error);
        });
    } catch (error) {
      handleError(error);
    }
  }

  

  async function getExclusionTransactionType(
    yesId,
    billingAccountNo,
    pageNo,
    pageSize
  ) {
    try {
      if (!isNetworkConnectionAvailable) {
        throw new Error(NO_INTERNET_CONNECTION_FOUND);
      }
      setProgressbarText(LOADING_PLEASE_WAIT);
      setLoading(true); // Hide the progress dialog

      const contentData = {
        billingAccountNo: billingAccountNo,
        //commissionType: commissionType,
        pageNumber: pageNo,
        pageSize: pageSize,
      };

      const encryptedContentData = await initializeEncryption(
        contentData,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.GET_PAYOUT_SUMMARY_TRANSACTION_TYPE
      );

      const transactionTypeRequestData = {
        requestId: generateRequestId(),
        loginId: getFromLocalStorage(LOGIN_ID),
        sessionId: getFromLocalStorage(SESSION_ID),
        loginUserName: getFromLocalStorage(USER_NAME),
        contentData: encryptedContentData,
      };

      getExclusionTransactionTypeRequest(transactionTypeRequestData)
        .then((response) => {
          const responseData = response.data.result.exclusionTransactionTypes.content.map((row) => ({
            ...row,
            id: generateRandomId(),
          }));
          setTransactionType(responseData);
          setRowsPerPage(response.data.result.exclusionTransactionTypes.content.length);
          setTotalNoOfRows(response.data.result.totalElements);
          setTotalNoOfPages(response.data.result.totalPages);

          setLoading(false);
          DebugLog(
            "getExclusionTransactionType response.data=====" +
              JSON.stringify(response.data)
          );
        })
        .catch((error) => {
          handleError(error);
        });
    } catch (error) {
      handleError(error);
    }
  }

  const startDownload = (fileType) => {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(DOWNLOADING_REPORT);
        setLoading(true);

        checkPageNavTransactionDetails();
        const requestObject = {
          // fromDate: params.fromDate,
          // toDate: params.toDate,
          // accountCode: params.code,
          // accountName: params.name,
          // reason: params.reason,

          reportTemplate: "PAYOUT_REPORT",
          reportFormat: fileType,
          batchId: selectedPayoutCycle?.batchNo,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.EARMARK_REPORT_DOWNLOAD
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          downloadPayoutsReports(requestData)
            .then((response) => {
              setLoading(false);


              let blob;
              const currentDate = new Date();
              const day = String(currentDate.getDate()).padStart(2, '0');
              const month = String(currentDate.getMonth() + 1).padStart(2, '0');
              const year = String(currentDate.getFullYear());

              // let filename be "EarmarkReport_YYYY-MM-DD"
              let filename = `PayoutsReport_${year}-${month}-${day}`;
              switch(fileType) {
                case 'CSV':
                  blob = new Blob([response.data], {type: 'text/csv'});
                  filename = filename + '.csv';
                  break;
                case 'XLS':
                  blob = new Blob([response.data], {type: 'application/vnd.ms-excel'});
                  filename = filename + '.xls';
                  break;
                case 'PDF':
                  blob = new Blob([response.data], {type: 'application/pdf'});
                  filename = filename + '.pdf';
                  break;

                default:
                  throw new Error('Invalid file type');
              } 

              // Use FileSaver to save the file
              saveAs(blob, filename);
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  };


  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

 

  // handle error code reusable block
  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    }

    const errorCode = error.data?.errorCode;
    var errorMessage =
      error.response != null ? error.displayErrorMessage : "Unknown";
    if (error.data?.displayErrorMessage) {
      errorMessage = error.data.displayErrorMessage;
    }

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),
      // [ApiErrorCode.UNABLE_TO_PROCESS_ERROR]: () =>
      //   navigate(CONSTANT.FINANCE_DASHBOARD),
      default: () =>
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(errorMessage)
        ),
    };

    (errorActions[errorCode] || errorActions.default)();
  }

  function showErrorAlert(title, content) {
    try {
      DebugLog("error.data=====" + content);
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  /***** Navigation *******/
  const handleBackClicked = () => {
   // checkPageNavTransactionDetails();
   // if (selectedPayoutCycle.flowFrom === CONSTANT.PAYOUT_ROUTE) {
      navigate(CONSTANT.EXCLUSION_ROUTE);
    // } else {
    //   navigate(CONSTANT.FINANCE_DASHBOARD);
    // }
  };

  const handleRowClick = (params) => {

    checkPageNavTransactionDetails()

    navigate(CONSTANT.REMOVED_EXCLUSION_TRANSACTION_DETAILS_ROUTE, {
      state: { data: params.row },
    });

   
  };
  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />
        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}

        {/* Header */}
        <Grid container direction={"row"} alignItems={"center"} mb={2} ml={2}>
          <Grid item mr={2}>
            <IconButton onClick={handleBackClicked} width={12}>
              <img src={"../../assets/common/Back.svg"} width={12} />
            </IconButton>
          </Grid>
          <Grid item>
            <Typography
              color={colors.grey[100]}
              fontWeight={"600"}
              variant="h3"
            >
              {transactionTypeName}
            </Typography>
          </Grid>
        </Grid>
        {/* Header */}

        {/* Highlights Section */}

    

       { payoutDealerHeaderSummary !== null ? (
        <HighlightsPrimary
          highlightTotal={"RM " + formatPrice(payoutDealerHeaderSummary.totalPayOuts?payoutDealerHeaderSummary.totalPayOuts:0)}
          highlightPayOut={
            "RM " + formatPrice(payoutDealerHeaderSummary.netPayOuts.total?payoutDealerHeaderSummary.netPayOuts.total:0)
          }
          payoutDealers={payoutDealerHeaderSummary.netPayOuts.dealers?payoutDealerHeaderSummary.netPayOuts.dealers:0}
          payoutTransactions={payoutDealerHeaderSummary.netPayOuts.count?payoutDealerHeaderSummary.netPayOuts.count:0}


          onHold={"RM " + formatPrice(payoutDealerHeaderSummary.netPayOuts.total?payoutDealerHeaderSummary.netPayOuts.total:0)}
          onHoldDealers={payoutDealerHeaderSummary.netPayOuts.dealers?payoutDealerHeaderSummary.netPayOuts.dealers:0}
          onHoldTransactions={payoutDealerHeaderSummary.netPayOuts.count?payoutDealerHeaderSummary.netPayOuts.count:0}
        ></HighlightsPrimary>
      ) : (
        ""
      )}



          {/* {
    "responseId": "1718857846388-28224",
    "responseCode": "0",
    "responseMessage": "Success",
    "displayResponseMessage": "Success",
   "result": {
        "totalPayOuts": 18.6,
        "dealers": {
            "total": 0.6,
            "prepaid": 0,
            "postpaid": 0.6
        },
        "masterDealers": {
            "total": 17.4,
            "prepaid": 4.4,
            "postpaid": 13
        },
        "netPayOuts": {
            "total": 18.6,
            "dealers": 7,
            "count": 6
        }
    }
} */}

{ payoutDealerHeaderSummary !== null ? (
        <HighlightsSecondary
          highlightTotal={
            "RM " + formatPrice(payoutDealerHeaderSummary.dealers.total?payoutDealerHeaderSummary.dealers.total:0)
          }
          highlightTotal2={
            "RM " + formatPrice(payoutDealerHeaderSummary.masterDealers.total?payoutDealerHeaderSummary.masterDealers.total:0)
          }
          prepaidAmount={
            "RM " + formatPrice(payoutDealerHeaderSummary.dealers.prepaid?payoutDealerHeaderSummary.dealers.prepaid:0)
          }
          prepaidAmount2={
            "RM " +
            formatPrice(payoutDealerHeaderSummary.masterDealers.prepaid?payoutDealerHeaderSummary.masterDealers.prepaid:0)
          }
          postpaidAmount={
            "RM " + formatPrice(payoutDealerHeaderSummary.dealers.postpaid?payoutDealerHeaderSummary.dealers.postpaid:0)
          }
          postpaidAmount2={
            "RM " +
            formatPrice(payoutDealerHeaderSummary.masterDealers.postpaid?payoutDealerHeaderSummary.masterDealers.postpaid:0)
          }
        ></HighlightsSecondary>
      ) : (
        ""
      )}

    
        {/* Highlights Section */}

        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Validations Section */}
          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={2}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            pb={0}
          >
            <SectionHeader
              sectionIcon={"../../assets/common/Receipt.svg"}
              sectionHeading={"Transaction Type(s)"}
            ></SectionHeader>

            {/* <SimpleTable
          statusData={"In Validation"}
          statusBG={colors.primary[300]}
          data={transactionType}
        ></SimpleTable> */}

            {transactionType.length > 0 ? (
              <Box
                borderRadius={3}
                flex={1}
                m="0px 0 0 0"
                pb={0}
                height={gridHeight}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "none",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.redAccent[600],
                    fontWeight: "bold",
                    fontSize: 13,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "rgba(255,255,255,0.6)",
                    borderBottom: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                    color: `${colors.grey[300]} !important`,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    background: "rgba(255,255,255,1)",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: "rgba(255,255,255,0.6)",
                  },
                  "& .MuiCheckbox-root": {
                    //color: `${colors.white[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[300]} !important`,
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    // opacity:.5
                  },
                }}
              >
                <DataGrid
                  classes={{ row: "dataGridRow" }}
                  rows={transactionType}
                  columns={exclusionTransactionTypeColumnHeader}
                  // components={{ Toolbar: CustomToolbar }}
                  checkboxSelection
                  selectionModel={selectedRows}
                  onSelectionModelChange={handleSelectionChange}
                  disableSelectionOnClick // Disable row selection on row click
                  pageSize={pageSize}
                  rowCount={totalNoOfRows}
                  paginationModel={paginationModel}
                  paginationMode="server"
                  keepNonExistentRowsSelected
                  onPageChange={handlePageChange}
                  onPageSizeChange={handlePageSizeChange}
                  rowsPerPageOptions={[15, 30, 45, 60]}
                  // useResizeContainer
                  //           columnBuffer={2} // Adjusts the number of columns rendered outside the viewport
                  // autoPageSize // Automatically adjusts the page size based on the available height
                  autoHeight // Adjusts the height of the grid to fit its content
                  onRowClick={handleRowClick}
                />
              </Box>
            ) : (
              NoDataFound()
            )}
          </Grid>

          `{ transactionType.length > 0 ? (
            <Box item mt={6}>
              <Typography>
                <span>Jump to page: </span>
                <select
                  value={paginationModel.page + 1}
                  onChange={handlePageJump}
                >
                  {[...Array(totalNoOfPages)].map((_, index) => (
                    <option key={index} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              </Typography>
            </Box>
          ) : (
            ""
          )}

          {/* Validations Section */}
        </Grid>

       

        {/* Action Buttons */}

        {transactionType.length > 0 ? (
          <Grid item mt={1} justifyContent={"flex-start"} pb={20} mr={10}>
            <Stack direction="row" spacing={2} justifyContent={"flex-end"}>
             

              {downloadButtonVisible ? (
                <DownloadDropdownButton
                  onFileTypeSelected={startDownload}
                />
              ) : (
                ""
              )}

             
            </Stack>
          </Grid>
        ) : (
          ""
        )}

        {/* Action Buttons */}
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
};
export default RemovedExclusionTransactionTypeScreen;
